import { createAction, props } from '@ngrx/store';

import { CdwDrawerEntity } from './cdw-drawer.models';

export const initCdwDrawers = createAction('[CdwMatDrawer Page] Init');

export const loadCdwDrawersSuccess = createAction(
  '[CdwMatDrawer/API] Load CdwDrawers Success',
  props<{ cdwDrawers: CdwDrawerEntity[] }>()
);

export const loadCdwDrawersFailure = createAction(
  '[CdwMatDrawer/API] Load CdwDrawers Success',
  props<{ error: unknown }>()
);

export const closeAllDrawers = createAction('[CdwMatDrawer/API] Close All Drawers');

export const openDrawer = createAction('[CdwMatDrawer/API] Open Drawer', props<{ id: string }>());

export const closeDrawer = createAction('[CdwMatDrawer/API] Close Drawer', props<{ id: string }>());

export const addDrawer = createAction('[CdwMatDrawer/API] Add Drawer', props<CdwDrawerEntity>());

export const removeDrawer = createAction('[CdwMatDrawer/API] Remove Drawer', props<{ id: string }>());

export const toggleDrawer = createAction('[CdwMatDrawer/API] Toggle Drawer', props<{ id: string }>());
